import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';
import { AccountsTransfersStackRoutes, AccountsTransfersStackScreenProps } from './type';
import { AccountsTransfersWebTwoScreen } from './AccountsTransfersWebTwo.screen';
import { AccountsTransfersNativeTwoScreen } from './AccountsTransfersNativeTwo.screen';

export interface NewAccountProps {}
export const AccountsTransfersPlaced: React.FC<AccountsTransfersStackScreenProps<AccountsTransfersStackRoutes.Placed>> = ({
  navigation,
  route
}) => {
  const { onLayout, account, tab, data, returnData, refresh, record } = route.params;
  const layout = useContext(LayoutContext);
  const onGoBack = () => {
    navigation.goBack();
  };
  const { useModalProps, closeModal } = useModalView({});
  if (layout.isMobile) {
    return (
      <AccountsTransfersNativeTwoScreen
        onClose={onGoBack}
        account={account}
        tab={tab}
        data={data}
        returnData={returnData}
        refresh={refresh}
        record={record}
      />
    );
  }

  return (
    <AccountsTransfersWebTwoScreen
      onClose={closeModal}
      onLayout={onLayout}
      account={account}
      tab={tab}
      data={data}
      returnData={returnData}
      refresh={refresh}
      record={record}
    />
  );
};
